/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebounce } from 'utils';
import { manageAppsAPI } from 'services/manageApps.service';
import { CustomInput, ErrorComponent, Loader, ErrorForBtn } from 'components';
import { DeleteIcon } from 'assets/icons';
import { polipop } from 'constants';
import Footer from '../../footer/Footer';
import Content from './Content';
import { ErrorMarker } from 'assets/icons';
import * as S from './PublishedApp.styled';
import { useComputed, useSignalEffect, useSignal } from '@preact/signals-react';

function isAppExisting(store_package, allPackages) {
  if (!store_package) return false;
  return allPackages.includes(store_package);
}

export const PublishedAppTab = ({ handleClose, chooseAction, isWebsite = false }) => {
  const { t } = useTranslation();
  const [status, setStatus] = useState(false);
  const [getAppstoreData, appStoreDataResult] = manageAppsAPI.useLazyGetAppStoreDataQuery();
  const [saveNewGoogleApp, result] = manageAppsAPI.useSaveNewGoogleAppMutation();

  const [storeURL, setStoreURL] = useState('');
  const debouncedValue = useDebounce(storeURL, 500);
  const fatchedApp$ = useSignal({});

  const { data: appList, isSuccess } = manageAppsAPI.useFetchAppsToPromoteByFilterQuery(false);

  const allPackages = useMemo(() => {
    if (isSuccess) {
      const all_packages = appList?.map((appData) => appData.pba_url1)?.filter(Boolean);
      return [...new Set(all_packages)];
    }
    return [];
  }, [isSuccess]);

  const handleGoogleApp = useCallback((e) => {
    fatchedApp$.value = {};
    setStoreURL(e.target.value);
    setStatus(true);
  }, []);

  const deleteUrl = useCallback(() => {
    fatchedApp$.value = {};
    setStoreURL('');
    setStatus(false);
  }, []);

  useEffect(() => {
    if (!appStoreDataResult.isFetching) setStatus(false);
  }, [appStoreDataResult.isFetching]);

  useEffect(() => {
    const getApp = async () => {
      if (debouncedValue.length > 0) {
        const res = await getAppstoreData({
          packageName: debouncedValue,
        });
        fatchedApp$.value = res.data;
      }
    };
    getApp();
  }, [debouncedValue]);

  const handleSaveApp = async () => {
    if (result.isLoading) return; // prevent double-clicks

    try {
      const res = await saveNewGoogleApp({ store_url: fatchedApp$.value.store_url });
      console.log({ res });
      chooseAction(res);
      if (res.data) {
        handleClose(res.data.apps.appId);
      }
    } catch (err) {
      console.error('Save app failed:', err);
    }
  };

  // const existingFlag = useMemo(
  //   () => isAppExisting(fatchedApp$.value?.store_package, allPackages),
  //   [fatchedApp$.value?.store_package, isAppExisting, allPackages],
  // );

  const hasFetchedAppData = Object.keys(fatchedApp$.value || {}).length > 0;
  // const isDisabled = !hasFetchedAppData || existingFlag;
  const isDisabled = !hasFetchedAppData;

  useEffect(() => {
    if (result.isSuccess) {
      handleClose();
    }
    if (result.error) {
      polipop.add({
        content: 'Error',
        title: 'Error',
        type: 'error',
      });
    }
  }, [result]);

  return (
    <>
      <S.Container>
        {result.isLoading && <Loader.Global />}
        <S.Label htmlFor='storeURL'>
          {isWebsite ? 'Website URL:' : t('campaign.application.store_url')}
        </S.Label>
        <CustomInput
          value={storeURL}
          id='storeURL'
          name='storeURL'
          rightIcon={storeURL.length ? <DeleteIcon /> : null}
          rightIconOnClick={deleteUrl}
          placeholder='https://'
          onChange={handleGoogleApp}
          // error={existingFlag}
        />
        {/* {existingFlag && (
          <S.ExistingError>
            <ErrorMarker />
            Unable to add application. The application you are trying to add is already present in
            the list.
          </S.ExistingError>
        )} */}
        {appStoreDataResult.isError && <ErrorComponent style={{ paddingBottom: '32px' }} />}
        {appStoreDataResult.isFetching && <Loader.Global />}
        {appStoreDataResult?.isSuccess &&
          !fatchedApp$.value &&
          !appStoreDataResult?.isFetching &&
          storeURL &&
          !status && (
            <ErrorForBtn errorMsg='Invalid URL!' isOpen={true} style={{ marginTop: '5px' }} />
          )}
        {useComputed(() => (
          <>
            {fatchedApp$.value && Object.keys(fatchedApp$.value).length > 0 && (
              <Content {...fatchedApp$.value} />
            )}
          </>
        ))}
      </S.Container>
      <Footer
        handleClose={handleClose}
        handleSaveApp={handleSaveApp}
        isDisabled={isDisabled || result.isLoading}
        saveLabel={isWebsite ? 'Save Website' : 'Save App'}
      />
    </>
  );
};
